import React from "react";
import { createProps, getClass } from "./utils";
import Row from "./components/Row";
import Col from "./components/Col";

var FlexGrid = function FlexGrid(props) {
  var widthClass = props.fullWidth ? getClass("fullWidth") : "";
  var containerClass = getClass("containerFluid");
  var classNames = [containerClass, widthClass];

  if (props.className) {
    classNames.push(props.className);
  }

  return /*#__PURE__*/React.createElement(props.as || "div", createProps(props, classNames));
};

FlexGrid.Row = Row;
FlexGrid.Col = Col;
export default FlexGrid;